module.exports = __webpack_public_path__ + "static/media/gb10.d18d12f6.png";